import { render, staticRenderFns } from "./AnnotationsCanvasContext.vue?vue&type=template&id=5fa61d80&"
import script from "./AnnotationsCanvasContext.vue?vue&type=script&lang=js&"
export * from "./AnnotationsCanvasContext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports